import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { ROUTES } from '@traction/shared';
import { useAuth } from '@/contexts/AuthContext';

export function ProtectedRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-cacao-dark">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-cacao-dark-tertiary border-t-cacao-gold" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  if (!user.emailVerified && location.pathname !== ROUTES.VERIFY_EMAIL) {
    return <Navigate to={ROUTES.VERIFY_EMAIL} replace />;
  }

  // Onboarding redirect disabled - users can access dashboard directly
  // if (
  //   profile &&
  //   profile.onboarding_step !== 'completed' &&
  //   location.pathname !== ROUTES.ONBOARDING
  // ) {
  //   return <Navigate to={ROUTES.ONBOARDING} replace />;
  // }

  return <Outlet />;
}
